module.exports = __webpack_public_path__ + "res/ic_portrait_s.e25c9b5af5082a289d251c0e84e148ad.png";